module.exports = __webpack_public_path__ + "img/脸红.3b50cb60.png";